import {useNavigate, useSearchParams} from "react-router-dom";
import Grid from "@mui/material/Grid";
import * as React from "react";
import {useEffect, useState} from "react";
import useRootHook from "../../hooks/useRoot";
import helpers from "../../helpers/common";
import currencies from "../../models/currencies";
import CurrencyForm from "./CurrencyForm";
import PageHeader from '../layout/PageHeader';
import SectionCard from '../layout/SectionCard';

export default function CurrencyEdit() {
    const [searchParams] = useSearchParams();
    const {setShowLoader} = useRootHook()
    const navigate = useNavigate()
    const [currencyData, setCurrencyData] = useState(null)

    const [fields, setFields] = useState({})
    const [errors, setErrors] = useState({});

    useEffect(() => {
        setShowLoader(true)

        currencies.get(searchParams.get('id'))
            .then((currency) => {
                setShowLoader(false)
                if (!currency) return
                currency && setCurrencyData(currency)

                const fieldsData = {
                    id: currency.id,
                    currency: currency.currency,
                    subunit: currency.subunit.toString(),
                    symbol: currency.symbol,
                    enabled: currency.enabled !== false
                }
                setFields(fieldsData)
            }).catch(() => setShowLoader(false))

    }, [])

    const handleChange = (ev) => {
        const [, value, name] = helpers.getFormEventData(ev);

        setErrors({...errors, [name]: undefined});

        setFields((prevState) => {
            let newFields = {...prevState};
            newFields[name] = value;

            return newFields
        })
    }

    const handleBlur = (ev) => {
        const [, , name] = helpers.getFormEventData(ev)

        const newErrors = {...errors}
        const newFields = {...fields}

        typeof currencies.fieldValidator[name] === 'function'
        && currencies.fieldValidator[name](newFields, newErrors)

        setErrors(newErrors)
    }

    const handleSubmit = (ev) => {
        ev.preventDefault()
        const validationErrors = currencies.methodValidator.edit(fields)
        setErrors(validationErrors)

        if (Object.keys(validationErrors).length !== 0) return

        setShowLoader(true)
        currencies.edit(fields)
            .then(() => {
                setShowLoader(false)
                navigate('/currencies')
            }).catch(() => setShowLoader(false))
    }

    if (!currencyData) return null

    return <React.Fragment>
        <Grid size={12}>
            <PageHeader title={`Edit currency: ${currencyData.currency}`} breadcrumbs={[['Dashboard', '/'], ['Currencies', '/currencies'], ['Edit', `/currencies/edit?id=${currencyData.id}`]]} />
        </Grid>
        <Grid size={12}>
            <SectionCard sx={{ display: 'flex', flexDirection: 'column' }}>
                <CurrencyForm fields={fields} errors={errors} handleChange={handleChange}
                              handleBlur={handleBlur} handleSubmit={handleSubmit} />
            </SectionCard>
        </Grid>
    </React.Fragment>
}